const getRegions = () => {
  const regions = localStorage.getItem("regions")
    ? JSON.parse(localStorage.getItem("regions"))
    : null;

  if (regions) return regions;

  return null;
};

const InitialState = {
  regions: getRegions(),
};

const RegionsDataReducer = (state = InitialState, action) => {
  if (action.type === "Save_Regions_Data") {
    const newState = {
      regions: action.payload,
    };

    localStorage.setItem("regions", JSON.stringify(action.payload));

    return newState;
  }

  return state;
};

export default RegionsDataReducer;
